import "./App.css";
import Header from "./components/header/Header";
import Parallax from "./components/parallax/Parallax";
import About from "./components/about/About";
import Experience from "./components/experience/Experience";
import Portfolio from "./components/portfolio/Portfolio";
import Testimonial from "./components/testimonial/Testimonial";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
// import Cloud from "./components/footer/Cloud";

function App() {
    return (
        <>
            <Header/>
            <Parallax/>
            <About/>
            <Experience/>
            <Portfolio/>
            <Testimonial/>
            <Contact/>
            {/* <Cloud/> */}
            <Footer/>
        </>
    );
}

export default App;
